import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { CheckCircle } from 'lucide-react';

const AboutSection = () => {
  const { t } = useLanguage();

  const products = [
    'tcmPowderFull',
    'tcmCakeFull',
    'jabajCakeFull',
    'oilBasedSoapFull',
    'liquidFull',
  ];

  return (
    <section id="about" className="bg-slate-50 section-spacing" data-testid="about-section">
      <div className="container-custom">
        <h2 
          className="text-3xl md:text-5xl font-bold text-[#0047AB] text-center mb-4"
          data-testid="about-title"
        >
          {t('aboutTitle')}
        </h2>
        <div className="section-divider mb-12"></div>

        <div className="max-w-4xl mx-auto">
          <p className="text-base md:text-lg text-slate-600 leading-relaxed mb-8" data-testid="about-intro">
            {t('aboutIntro')}
          </p>

          <p className="font-semibold text-slate-800 mb-4">{t('aboutProducts')}</p>

          <ul className="space-y-3 mb-8" data-testid="about-products-list">
            {products.map((product, index) => (
              <li key={index} className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-[#0047AB] flex-shrink-0 mt-0.5" />
                <span className="text-slate-600">{t(product)}</span>
              </li>
            ))}
          </ul>

          <p className="text-slate-600 leading-relaxed p-6 bg-white border-l-4 border-[#0047AB]" data-testid="about-conclusion">
            {t('aboutConclusion')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
